module.exports = __webpack_public_path__ + "img/utalkNoTime_dark.feb965fd.png";